import { render } from "./settings-controllers-TimeUseTariff.vue?vue&type=template&id=5cde6734"
import script from "./settings-controllers-TimeUseTariff.vue?vue&type=script&lang=js"
export * from "./settings-controllers-TimeUseTariff.vue?vue&type=script&lang=js"

import "./settings-controllers-TimeUseTariff.vue?vue&type=style&index=0&id=5cde6734&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__